import React from 'react';
import PropTypes from 'prop-types';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import AuthContext from "flexbiz-core/components/auth/Context";
function ButtonNavi({defaultValue,history,code,style}){
  if(defaultValue==undefined && code){
    if(code=="dmvt_agent_midomax") defaultValue = 1;
    if(code=="dh2_agent_midomax") defaultValue = 2;
    if(code=="profile") defaultValue = 3;
  }


  const [value, setValue] = React.useState(defaultValue||0);
  const context = React.useContext(AuthContext);
  return (
    <Paper style={{...(style||{}),overflow:"hidden",borderRadius:0}} elevation={3}>
        <BottomNavigation
          style={{borderTop:"1px solid #ddd",marginBottom: ((context.queryParams||{}).os||"").toLowerCase()=="ios"?10:0}}
          showLabels
          value={value}
          onChange={(event, newValue) => {
            switch(newValue){
              case 0:
                setValue(newValue);
                history.replace('/')
                break;
              case 1:
                setValue(newValue);
                history.push('/list/dmvt_agent_midomax')
                break;
              case 2:
                setValue(newValue);
                history.push(`/list/dh2_agent_midomax`)
                break;
              case 3:
                setValue(newValue);
                history.push(`/profile`)
                break;
            }
          }}
        >
          <BottomNavigationAction label={<Typography noWrap style={{width:"100%"}} >{context.apis.getLabel("Home")}</Typography>} icon={<img src="/images/Home.png" style={{width:24,height:24}} />} />
          <BottomNavigationAction label={<Typography noWrap style={{width:"100%"}} >{context.apis.getLabel("Cửa hàng")}</Typography>} icon={<img src="/images/shop.png" style={{width:24,height:24}} />} />
          <BottomNavigationAction label={<Typography noWrap style={{width:"100%"}} >{context.apis.getLabel("Đơn hàng")}</Typography>} icon={<img src="/images/don_hang.png" style={{width:24,height:24}} />} />
          <BottomNavigationAction label={<Typography noWrap style={{width:"100%"}} >{context.apis.getLabel("Tài khoản")}</Typography>} icon={<img src="/images/profile.png" style={{width:24,height:24}} />} />
        </BottomNavigation>
      </Paper>
  )
}
ButtonNavi.propTypes={
  mediaQueryMatches: PropTypes.bool,
  history:PropTypes.any,
  match:PropTypes.any,
  defaultValue:PropTypes.number,
  code:PropTypes.any,
  style:PropTypes.any
}
export default  ButtonNavi;
